module.exports = __webpack_public_path__ + "static/img/brian-kairuz-5JHj33-s604.3a66d02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/brian-kairuz-5JHj33-s604.jpg
// module id = Yppf
// module chunks = 1